/* Pull Mania: il sottomenu compare sotto la voce del menu scelta, non sempre a sinistra (03/10/2026) */
/* Sottomenu a riquadro sotto la voce scelta (Luca, 03/10/2026, con esempio): la posizione
   si calcola rispetto al contenitore vero del sottomenu, così funziona qualunque sia. */
(function () {
  function posiziona(voce) {
    var sub = voce.querySelector(':scope > .menu-list__submenu');
    if (!sub || window.innerWidth < 750) return;
    var link = voce.querySelector('.menu-list__link') || voce;
    var base = sub.offsetParent || document.body;
    var v = link.getBoundingClientRect(), o = base.getBoundingClientRect();
    var x = Math.round(v.left - o.left + v.width / 2), y = Math.round(v.bottom - o.top);
    sub.style.setProperty('--pm-sx', x + 'px'); sub.style.setProperty('--pm-sy', y + 'px');
    // correzione: misura dove è finito davvero e sposta la differenza
    var box = sub.querySelector('.menu-list__submenu-inner') || sub;
    var r = box.getBoundingClientRect();
    if (r.height) {
      var dx = (v.left + v.width / 2) - (r.left + r.width / 2), dy = (v.bottom + 6) - r.top;
      if (Math.abs(dx) > 1) sub.style.setProperty('--pm-sx', Math.round(x + dx) + 'px');
      if (Math.abs(dy) > 1) sub.style.setProperty('--pm-sy', Math.round(y + dy) + 'px');
    }
  }
  function collega() {
    document.querySelectorAll('.header-menu .menu-list__list-item').forEach(function (voce) {
      if (voce.dataset.pmRiquadro) return; voce.dataset.pmRiquadro = '1';
      posiziona(voce);
      ['pointerenter', 'focusin', 'click'].forEach(function (ev) { voce.addEventListener(ev, function () { posiziona(voce); }); });
    });
  }
  if (document.readyState !== 'loading') collega(); else document.addEventListener('DOMContentLoaded', collega);
  window.addEventListener('load', function () { document.querySelectorAll('.header-menu .menu-list__list-item').forEach(posiziona); });
  window.addEventListener('resize', function () { document.querySelectorAll('.header-menu .menu-list__list-item').forEach(posiziona); });
})();

/* Bandierine della lingua nei sottomenu (Luca, 03/10/2026). SVG, perché su Windows le emoji delle bandiere non si vedono. */
(function () {
  var B = {
    giapponese: '<svg viewBox="0 0 30 30"><rect width="30" height="30" fill="#fff"/><circle cx="15" cy="15" r="8.5" fill="#BC002D"/></svg>',
    cinese: '<svg viewBox="0 0 30 30"><rect width="30" height="30" fill="#DE2910"/><polygon fill="#FFDE00" points="10,5 11.8,10.4 17.5,10.4 12.9,13.7 14.6,19.1 10,15.8 5.4,19.1 7.1,13.7 2.5,10.4 8.2,10.4"/><circle cx="20" cy="5.5" r="1.3" fill="#FFDE00"/><circle cx="23" cy="9" r="1.3" fill="#FFDE00"/><circle cx="23" cy="13.5" r="1.3" fill="#FFDE00"/><circle cx="20" cy="17" r="1.3" fill="#FFDE00"/></svg>',
    italiano: '<svg viewBox="0 0 3 3"><rect width="1" height="3" fill="#009246"/><rect x="1" width="1" height="3" fill="#fff"/><rect x="2" width="1" height="3" fill="#CE2B37"/></svg>',
    inglese: '<svg viewBox="0 0 60 60"><rect width="60" height="60" fill="#012169"/><path d="M0,0 60,60 M60,0 0,60" stroke="#fff" stroke-width="12"/><path d="M0,0 60,60 M60,0 0,60" stroke="#C8102E" stroke-width="5"/><path d="M30,0 v60 M0,30 h60" stroke="#fff" stroke-width="18"/><path d="M30,0 v60 M0,30 h60" stroke="#C8102E" stroke-width="10"/></svg>'
  };
  function bandiere() {
    document.querySelectorAll('.mega-menu__link, .menu-drawer a, .menu-list--mobile a').forEach(function (a) {
      if (a.querySelector('.pm-bandiera')) return;
      var t = (a.textContent || '').trim().toLowerCase();
      if (!B[t]) return;
      var s = document.createElement('span');
      s.className = 'pm-bandiera';
      s.innerHTML = B[t];
      a.insertBefore(s, a.firstChild);
      a.classList.add('pm-lingua');
    });
  }
  if (document.readyState !== 'loading') bandiere(); else document.addEventListener('DOMContentLoaded', bandiere);
  var attesa = false;
  new MutationObserver(function () {
    if (attesa) return; attesa = true;
    requestAnimationFrame(function () { attesa = false; bandiere(); });
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();

/* Barra in alto: nastro continuo a tutta larghezza (Luca, 03/10 e 12/10/2026). La frase si ripete
   finché metà nastro copre la barra, così scorre sempre senza buchi; ogni frase passa in 10 secondi. */
(function () {
  function controlla() {
    document.querySelectorAll('.announcement-bar__text').forEach(function (p) {
      if (!p.dataset.pmTesto) p.dataset.pmTesto = p.innerHTML.trim();
      var testo = p.dataset.pmTesto;
      p.classList.remove('pm-scorre');
      p.innerHTML = '<span class="pm-misura" style="display:inline-block;white-space:nowrap;padding-right:3em">' + testo + '</span>';
      var box = p.closest('.announcement-bar__slide') || p.parentElement;
      var frase = p.firstChild.getBoundingClientRect().width || 1;
      var volte = Math.max(1, Math.ceil(box.clientWidth / frase));
      var meta = '';
      for (var i = 0; i < volte; i++) meta += '<span' + (i ? ' aria-hidden="true"' : '') + '>' + testo + '</span>';
      p.classList.add('pm-scorre');
      p.innerHTML = '<span class="pm-nastro" style="animation-duration:' + (10 * volte) + 's">' + meta +
        meta.replace(/<span>/g, '<span aria-hidden="true">') + '</span>';
    });
  }
  var t;
  if (document.readyState !== 'loading') controlla(); else document.addEventListener('DOMContentLoaded', controlla);
  window.addEventListener('load', controlla);
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(controlla, 150); });
})();

/* Quantità: mai oltre i pezzi disponibili (max dell'input, Luca 03/10/2026). Il + resta
   cliccabile: al massimo mostra un avviso, altrimenti sembra rotto. */
(function () {
  function campo(el) { var b = el.closest('.quantity-selector'); return b && b.querySelector('input[type="number"]'); }
  function avviso(input) {
    var max = parseInt(input.getAttribute('max'), 10);
    var nel = parseInt(input.dataset.cartQuantity || '0', 10);
    var inCarrello = input.hasAttribute('data-cart-line');
    var testo = (!inCarrello && nel > 0)
      ? (max <= 1 && nel > 0 && parseInt(input.value, 10) >= max
          ? 'Hai già nel carrello ' + nel + (nel === 1 ? ' pezzo' : ' pezzi') + ': ' + (max + nel) + ' disponibili in tutto.'
          : 'Disponibili ' + (max + nel) + ' pezzi, ' + nel + ' già nel carrello.')
      : (max === 1 ? 'Disponibile solo 1 pezzo.' : 'Disponibili solo ' + max + ' pezzi.');
    var wrap = input.closest('.quantity-selector-wrapper') || input.closest('.quantity-selector').parentElement;
    var box = wrap.querySelector('.pm-avviso-scorte');
    if (!box) {
      box = document.createElement('div'); box.className = 'pm-avviso-scorte'; box.setAttribute('role', 'status');
      wrap.appendChild(box);
    }
    box.textContent = '⚠️ ' + testo;
    box.classList.remove('pm-vedi'); void box.offsetWidth; box.classList.add('pm-vedi');
    clearTimeout(box._t); box._t = setTimeout(function () { box.classList.remove('pm-vedi'); }, 3500);
  }
  function limita(input) {
    var max = parseInt(input.getAttribute('max'), 10), v = parseInt(input.value, 10);
    if (max && v > max) { input.value = max; input.dispatchEvent(new Event('change', { bubbles: true })); avviso(input); }
    var box = input.closest('.quantity-selector'), piu = box && box.querySelector('.quantity-plus');
    if (piu) { piu.removeAttribute('disabled'); piu.classList.toggle('pm-al-massimo', !!max && parseInt(input.value, 10) >= max); }
  }
  document.addEventListener('click', function (e) {
    var piu = e.target.closest('.quantity-plus');
    if (piu) {
      var input = campo(piu), max = input && parseInt(input.getAttribute('max'), 10);
      if (input && max && parseInt(input.value, 10) >= max) { e.preventDefault(); e.stopImmediatePropagation(); avviso(input); return; }
    }
    var b = e.target.closest('.quantity-plus, .quantity-minus');
    if (b && campo(b)) { var i = campo(b); setTimeout(function () { limita(i); }, 0); }
  }, true);
  document.addEventListener('input', function (e) { if (e.target.matches('.quantity-selector input[type="number"]')) limita(e.target); });
  document.addEventListener('change', function (e) { if (e.target.matches('.quantity-selector input[type="number"]')) limita(e.target); }, true);
  function tutti() { document.querySelectorAll('.quantity-selector input[type="number"]').forEach(limita); }
  if (document.readyState !== 'loading') tutti(); else document.addEventListener('DOMContentLoaded', tutti);
})();

/* Pagina prodotto: foto alta quanto la parte scritta di fianco (Luca, 03/10/2026) */
(function () {
  function misura() {
    var pagina = document.querySelector('.product-information');
    if (!pagina || window.innerWidth < 750) return;
    var testo = pagina.querySelector('.product-details');
    if (!testo) return;
    var figli = testo.querySelectorAll(':scope > *, :scope > * > *');
    var alto = 0, top = testo.getBoundingClientRect().top;
    figli.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.height) alto = Math.max(alto, r.bottom - top); });
    if (!alto) return;
    var lato = Math.max(320, Math.min(Math.round(alto), Math.round(window.innerHeight * 0.75)));
    pagina.style.setProperty('--pm-lato-foto', lato + 'px');
  }
  var t;
  function presto() { clearTimeout(t); t = setTimeout(misura, 100); }
  if (document.readyState !== 'loading') misura(); else document.addEventListener('DOMContentLoaded', misura);
  window.addEventListener('load', misura);
  window.addEventListener('resize', presto);
})();

/* Quantità e carrello nel riquadro del prodotto (Luca, 03/10/2026) */
(function () {
  function avvisa(form, testo) {
    var b = form.querySelector('.pm-avviso-scorte'); if (!b) return;
    b.textContent = testo; b.classList.remove('pm-vedi'); void b.offsetWidth; b.classList.add('pm-vedi');
    clearTimeout(b._t); b._t = setTimeout(function () { b.classList.remove('pm-vedi'); }, 3000);
  }
  function aggiorna(form) {
    var i = form.querySelector('input[name="quantity"]'), max = parseInt(i.max, 10), v = parseInt(i.value, 10) || 1;
    if (v < 1) v = 1; if (max && v > max) v = max; i.value = v;
    form.querySelector('.pm-qta__piu').classList.toggle('pm-al-massimo', !!max && v >= max);
  }
  // i clic dentro il riquadro quantità/carrello non arrivano alla scheda (che aprirebbe il prodotto)
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.pm-carrello') && !e.target.closest('.pm-qta__piu, .pm-qta__meno')) e.stopPropagation();
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.pm-carrello .pm-qta__piu, .pm-carrello .pm-qta__meno');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var form = b.closest('form'), i = form.querySelector('input[name="quantity"]'), max = parseInt(i.max, 10), v = parseInt(i.value, 10) || 1;
    if (b.classList.contains('pm-qta__piu')) {
      if (max && v >= max) { avvisa(form, '⚠️ ' + (max === 1 ? 'Disponibile solo 1 pezzo.' : 'Disponibili solo ' + max + ' pezzi.')); return; }
      i.value = v + 1;
    } else i.value = Math.max(1, v - 1);
    aggiorna(form);
  }, true);
  document.addEventListener('change', function (e) { var f = e.target.closest && e.target.closest('.pm-carrello'); if (f) aggiorna(f); });
  /* Stesso procedimento del tema (product-form.js): evento CartLinesUpdateEvent + sezioni del
     carrello, così tendina, numero sull'icona e apertura automatica si aggiornano da soli. */
  function carrelloAggiornato() {
    var c = document.querySelector('cart-items-component');
    if (c && typeof c.fetchCartData === 'function') return c.fetchCartData();
    return fetch(Theme.routes.cart_url + '.json', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-pm-carrello]');
    if (!form) return;
    e.preventDefault(); e.stopPropagation(); aggiorna(form);
    var tasto = form.querySelector('.pm-aggiungi'); if (tasto.disabled) return; tasto.disabled = true;
    if (typeof window.pmAggiungi !== 'function') { form.submit(); return; }
    window.pmAggiungi(form).then(function (esito) {
      if (esito.errore) avvisa(form, '⚠️ ' + (esito.messaggio || 'Non disponibile in questa quantità.'));
      else { tasto.classList.add('pm-fatto'); setTimeout(function () { tasto.classList.remove('pm-fatto'); }, 1500); }
    }).catch(function (err) {
      // ripiego: se il tema non risponde, si va alla pagina del carrello
      console.error('[pm-carrello]', err && (err.stack || err));
      form.submit();
    }).finally(function () { tasto.disabled = false; });
  }, true);
})();

/* Consigliati: via gli esauriti, massimo 6 (Luca, 04/10/2026). I consigliati della pagina
   prodotto arrivano dopo il caricamento, quindi si ricontrolla quando la pagina cambia. */
(function () {
  var SEZ = '[id$="__product_list_NNFgcy"], [id$="__product_recommendations_qggXJq"]';
  function sistema() {
    document.querySelectorAll(SEZ).forEach(function (s) {
      var visti = 0;
      s.querySelectorAll('product-card').forEach(function (card) {
        var voce = card.closest('li, .product-grid__item, .resource-list__item') || card;
        var fuori = card.classList.contains('pm-esaurito') || visti >= 6;
        voce.classList.toggle('pm-consigli-fuori', fuori);
        if (!fuori) visti++;
      });
    });
  }
  var attesa = false;
  function presto() { if (attesa) return; attesa = true; requestAnimationFrame(function () { attesa = false; sistema(); }); }
  if (document.readyState !== 'loading') sistema(); else document.addEventListener('DOMContentLoaded', sistema);
  new MutationObserver(presto).observe(document.documentElement, { childList: true, subtree: true });
})();
